
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircleIcon } from "lucide-react";

interface CredentialsErrorAlertProps {
  missingCredentials: string[];
}

export const CredentialsErrorAlert = ({ missingCredentials }: CredentialsErrorAlertProps) => {
  return (
    <Alert variant="destructive" className="mb-8 max-w-3xl mx-auto">
      <AlertCircleIcon className="h-4 w-4" />
      <AlertTitle>PayPal Configuration Missing</AlertTitle>
      <AlertDescription>
        <p className="mb-2">
          The PayPal integration is not properly configured. The following environment variables are missing:
        </p>
        <ul className="list-disc list-inside">
          {missingCredentials.map(cred => (
            <li key={cred}>{cred}</li>
          ))}
        </ul>
        <p className="mt-2">
          Please contact the administrator to complete the PayPal setup.
        </p>
      </AlertDescription>
    </Alert>
  );
};
